export enum LocationQueryKeys {
  GetLocation = 'LocationGetLocation',
  SearchLocationMap = 'SearchLocationMap',
}
